import React = require('react');
import { capitalize, get, startCase, toLower } from 'lodash';
import { useState } from 'react';
import { formatToDate } from '../../../../../../../../../../data/api/transformers/application';

interface IMTACoverDetailProps {
  metadata: any;
  selectedScheme: any
  isAnnual: boolean
  policyApplication: any
  noPadding?: boolean
}

export const MTACoverDetails = ({
                                  metadata,
                                  policyApplication,
                                  selectedScheme,
                                  isAnnual,
                                  noPadding
                                }: IMTACoverDetailProps) => {

  const [showCoverDetails, setShowCoverDetails] = useState(false);

  const handleOnClick = () => {
    setShowCoverDetails(!showCoverDetails)
  }

  const renderStates = (): string => {
    if (metadata.state_cities && metadata.state_cities.length) {
      return metadata.state_cities.join(', ');
    }
    return '';
  }

  const startDateFromApplication = get(policyApplication, 'commencesAt', formatToDate(get(policyApplication, 'starts_at')));
  const endDateFromApplication = get(policyApplication, 'expiresAt', formatToDate(get(policyApplication, 'ends_at')));

  const stateCities = renderStates();
  const maxTripDuration = get(metadata, 'max_trip_duration');
  const startDate = startDateFromApplication;
  const endDate = endDateFromApplication;

  const renderDestinations = (): string => {
    if (metadata.region) {
      const region = metadata.region === 'uk' ? 'United Kingdom' : metadata.region;
      return startCase(toLower(region));
    }

    if (metadata.destinations) {
      return metadata.destinations.join(', ');
    }

    return '';
  }

  const coverLevel = selectedScheme?.scheme?.cover_level || selectedScheme?.scheme?.coverLevel

  return (
    <div className={'details-overview'}>
      <div className={noPadding ? 'details-overview-header no_padding' : 'details-overview-header'}
           style={{ cursor: 'pointer' }} onClick={handleOnClick}>
        <div className={'d-overview-icon'}>
          <img src={require('../../../../../../Images/clipboard.svg')} width={'45px'} alt={''}/>
        </div>
        <div className={'d-overview-text'}>Your Cover Details</div>
        <div className={'d-overview-dropdown-icon'}>
          <img src={require('../../../../../../Images/arrow-down-sign-to-navigate.svg')} width={'45px'} alt={''}/>
        </div>
      </div>

      {showCoverDetails && (
        <>
          <div className={'details-overview-row'}>
            <div className={'d-o-attribute'}>
              <div>Trip Start Date</div>
              <div className={'d-o-attribute-value'}>{startDate}</div>
            </div>
          </div>
          <div className={'details-overview-row'}>
            <div className={'d-o-attribute'}>
              <div>Trip End Date</div>
              <div className={'d-o-attribute-value'}>{endDate}</div>
            </div>
          </div>
          <div className={'details-overview-row'}>
            <div className={'d-o-attribute'}>
              <div>Tier</div>
              <div className={'d-o-attribute-value'}>{capitalize(coverLevel)}</div>
            </div>
          </div>
          <div className={'details-overview-row'}>
            <div className={'d-o-attribute'}>
              <div>Destination</div>
              <div className={'d-o-attribute-value'}>{renderDestinations()}</div>
            </div>
          </div>

          {!isAnnual && stateCities.length > 0 && (
            <div className={'details-overview-row'}>
              <div className={'d-o-attribute'}>
                <div>States and Cities</div>
                <div className={'d-o-attribute-value'}>{renderStates()}</div>
              </div>
            </div>
          )}

          {isAnnual && maxTripDuration && (
            <div className={'details-overview-row'}>
              <div className={'d-o-attribute'}>
                <div>Maximum individual trip length</div>
                <div className={'d-o-attribute-value'}>{maxTripDuration + ' days'}</div>
              </div>
            </div>
          )}
        </>

      )}
    </div>
  )
}
